export const THOUSAND_SUFFIX = 'K';
export const MILLION_SUFFIX = 'M';

export const THOUSAND_LIMIT = 1000;
export const MILLION_LIMIT = 1000000;

export const convertQuantity = (
  quantity: number,
  lower: boolean = false
): string => {
  let suffix: string = '';
  let isHaveRemainder: boolean = false;
  let mainContentDisplay: number = quantity;

  if (quantity / THOUSAND_LIMIT >= 1) {
    suffix = THOUSAND_SUFFIX;
    isHaveRemainder = !!(quantity % THOUSAND_LIMIT);
    mainContentDisplay = Math.floor(quantity / THOUSAND_LIMIT);
  }
  if (quantity / MILLION_LIMIT >= 1) {
    suffix = MILLION_SUFFIX;
    isHaveRemainder = !!(quantity % MILLION_LIMIT);
    mainContentDisplay = Math.floor(quantity / MILLION_LIMIT);
  }

  return `${mainContentDisplay}${lower ? suffix.toLocaleLowerCase() : suffix}${
    isHaveRemainder ? '+' : ''
  }`;
};

export const convertQuantityToLocaleString = (quantity: number) => {
  return quantity.toLocaleString('vi-VN').replace('.', ',');
};
